import { clsx } from 'clsx';
import { Star } from 'lucide-react';

export interface StrategyBadgeProps {
  status?: string;
  segment?: 'lapsed' | 'vip' | 'debtor';
  reviewRating?: number;
  className?: string;
}

export function StrategyBadge({ status, segment, reviewRating, className }: StrategyBadgeProps) {
  // 1. Campaign Segment Badge
  if (segment) {
    const segmentConfigs = {
      lapsed: { label: 'Inactivo', bg: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20' },
      vip: { label: 'VIP ⭐', bg: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20' },
      debtor: { label: 'Saldo Pendiente', bg: 'bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/20' },
    };
    const config = segmentConfigs[segment] || segmentConfigs.lapsed;
    return (
      <span className={clsx('inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border', config.bg, className)}>
        {config.label}
      </span>
    );
  }

  // 2. Appointment Status & Strategy Badge
  const st = (status || 'new').toLowerCase().replace('_', '-');
  
  const statusMap: Record<string, { label: string; strategy: string; bg: string }> = {
    unconfirmed: { label: 'No confirmada', strategy: 'Recordatorio', bg: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20' },
    confirmed: { label: 'Confirmada', strategy: 'Recordatorio', bg: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20' },
    new: { label: 'Nueva', strategy: 'Por Confirmar', bg: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20' },
    arrived: { label: 'Llegó', strategy: 'En Recepción', bg: 'bg-teal-500/10 text-teal-600 dark:text-teal-400 border-teal-500/20' },
    started: { label: 'En Curso', strategy: 'Atendiendo', bg: 'bg-sky-500/10 text-sky-600 dark:text-sky-400 border-sky-500/20' },
    completed: { label: 'Completada', strategy: reviewRating ? `${reviewRating}★ Reseña` : 'Fidelización', bg: 'bg-slate-500/10 text-slate-700 dark:text-slate-300 border-slate-500/20' },
    'no-show': { label: 'No Asistió', strategy: 'Reprogramar', bg: 'bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/20' },
    cancelled: { label: 'Cancelada', strategy: 'Reenganche', bg: 'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20' },
  };

  const item = statusMap[st] || statusMap.new;

  return (
    <div className={clsx('inline-flex items-center gap-1.5', className)}>
      {reviewRating != null && reviewRating > 0 && (
        <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-500/15 text-amber-600 dark:text-amber-400 border border-amber-500/20">
          <Star size={10} className="fill-amber-500 text-amber-500" />
          {reviewRating}
        </span>
      )}
      <span className={clsx('inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border', item.bg)}>
        {item.label}
      </span>
    </div>
  );
}
